export default __webpack_public_path__ + "static/media/project-1.3.6623a870.png";